import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotComicsSection from './components/HotComicsSection';
import CategorySection from './components/CategorySection';
import SidebarSection from './components/SidebarSection';
import FeaturesBar from './components/FeaturesBar';
import { faqData, siteInfo } from '@/mocks/comics';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: `https://${siteInfo.domain}`,
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: `https://${siteInfo.domain}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: `https://${siteInfo.domain}`,
  description: siteInfo.description,
  foundingDate: siteInfo.established,
  contactPoint: {
    '@type': 'ContactPoint',
    email: siteInfo.email,
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesBar />
          <HotComicsSection />
          <CategorySection />
          <SidebarSection />

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                  常见问题
                </h3>
              </div>
              <div className="space-y-3">
                {faqData.map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between cursor-pointer p-5 text-sm font-semibold text-foreground-950 hover:text-primary-500 transition-colors">
                      {faq.question}
                      <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}